import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEntubaOCRRequest } from "../interface/entuba/OCR/IEntubaOCRRequest";
import { IEntubaOCRResponse } from "../interface/entuba/OCR/IEntubaOCRResponse";
import { IEntubaOCRDetailResponse } from "../interface/entuba/OCR/IEntubaOCRDetailResponse";
import { saveByteArray } from "src/util/saveByteArray";

enum EntubaOCRServiceEnum {
    base = "/",
    start = "/start",
    getAll = "/all",
    getDetail = "/detail/",
    download = "/download"

}

export default class EntubaOCRService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/entuba/ocr");
    }

    public getAll = async (): Promise<IEntubaOCRResponse[]> => this.GET(EntubaOCRServiceEnum.getAll);
    public getDetail = async (id: number): Promise<IEntubaOCRDetailResponse> => await this.GET(`${EntubaOCRServiceEnum.getDetail}${id}`);
    public start = async (data: IEntubaOCRRequest) => await this.POST(EntubaOCRServiceEnum.start, data);

    public download = async (id, fileName) => {
        const endpoint = EntubaOCRServiceEnum.download + "?id=" + id;
        const data = await this.GET(endpoint, "blob");
        saveByteArray(fileName, data);
        return data;
    };
}



// WEBPACK FOOTER //
// ./src/services/api/EntubaOCR.service.ts